var _rect, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBoxyface = function SvgBoxyface(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 17.0887,
    height: 16,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_29344_5410",
    transform: "translate(-0.0252354) scale(0.0228363 0.0243902)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_29344_5410",
    width: 46,
    height: 41,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAApCAYAAABKvBuPAAADEElEQVRYCb2XMY7UQBBF5xxcgnAlTkDCDcwliNmICIlLLE6Q9gATEZAxk3ABECnZHMHojfRna2qq7HLbHqRW2d1d/78ulz3Lbpf867vj2+fu58BItmw2LV8YZpv8+PB3+PXpdB73hMdLvjDMAuekFhyhe8BbaDxhmFX1CHxreA+9CNxXfSv4DLqp4sOrfwMjg+eprDEyaPnPbhUlRvCYMX5/GRYN6fAkNSiU9V4MjiBDZkuhlS896W8CvkaVBewj2oJfteJbQusQgl8ErkemKtCDn999uwzmZdga0bCaeMhP79bcHn/U6RESdCtgNY9DWHgYvr4/fiz/evbd4bvABU2sArTus14UDIa+OzyVwUlgIGRHK1A1z3pxLY4SeN8dL23ihbivQszdF3m9VP34OAnfd4c/UbUlrJfHxjkHYq/N1bX0fYSF1p0EZyNiXkCGenw+Vivs83Q/5VkCj6AxOJ1O6WCdvOwArFU1vD95TeBThjqQ4L1xBXpMA13evRSeRf/IuJdoJfp8oJdqkD/a51HFomo/vH4z2GEPtN/vb94P5uwem8u1XeM640grniVY4SnTCjh6YzoZR9gu+n77/vQVHzMEaFvw4LMIYNSfU+A6iJ7KFLj2+6h8YlRx2Ji/aZdoc/Q18Ia6l3F0eOa0rv0+aj0DF8tVu2Rtoi9C9eVStT0UOlbDr1to9kWHfwE37UK1s4orwRpbI117Q/2dTT4DmIrGFAfr53ZRtccSZMwezP1gPquSwNfQwIdxbpcquAAAlEAVWLmKrRryPf8YzQWXeRbVIj5m++fMp+CVxz1mxEsHsPpekTnWxnKn1uxTuqk4J8oE/Jcg2idw+790rsfAK7p4qdrEc4/zhtrJJVVvAY8K4OdstWG9/AjZPmfBJ1bvVVlfRR2oquP32cJeqi16u5jBWyAv3no/pem5xHsV/aYlbdN6EOX59oDtCtbfeHjuEbnHIeQTMXjO8N73vBWSuCqzNErPetjrm54Oid3k2AEk3gqu/Cw2ATv+HSKVQ2QQ1Xn5eP/V7mWwVmwB+w806H15IyBCtgAAAABJRU5ErkJggg=="
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBoxyface, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/boxyface.4c232ac7.svg";
export { ForwardRef as ReactComponent };